import axios from 'axios';
import config from '../config';
import {JsonHeaders} from '../constants';

export default {
    getPmtaEmailTest(id) {
        return axios.get(config.publicPath + 'pmta_email_tests/' + id, {
            headers: JsonHeaders
        });
    },
    getPmtaEmailTests(currentPage, perPage, orderField, orderDirection, pmtaRelay, status, user_id) {
        let parameters = {
            _page: currentPage,
            itemsPerPage: perPage,
            "pmtaRelay.smtpHost": pmtaRelay,
            status: status,
            "user.id": user_id
        };
        parameters['order[' + orderField +']'] = orderDirection;
        return axios.get(config.publicPath + 'pmta_email_tests', {
            params: parameters,
            headers: JsonHeaders
        });
    },
    createPmtaEmailTest(formData) {
        return axios.post(config.publicPath + 'pmta-email-test', formData, {
            headers: JsonHeaders,
            validateStatus: function (status) {
                return status >= 200 && status <= 500;
            },
        });
    },
    getEmailTestStatuses() {
        return axios.get(config.publicPath + 'pmta-email-test/statuses', {
            headers: JsonHeaders
        });
    },
}
